
export const coordinatesCity = {
    "1": [43.68, 40.23],
    "2": [43.41, 39.96],
    "3": [43.68, 40.26]
}

export const CENTER_MAP = [59.967358, 30.298686];
export const ZOOM_MAP = 11;


export const MODULE_NAME = 'room-list';
export const LOCAL_STORAGE_EXPIRE_ITEM = `${MODULE_NAME}:expire`;
export const LOCAL_STORAGE_ROOMS_ITEM = `${MODULE_NAME}:prices`;
export const LOCAL_STORAGE_CACHE_VALUE = 1440;
export const LOCAL_STORAGE_CACHE_MEASURE = 'minute';
export const LOCAL_STORAGE_EMPTY_CACHE = '';

export const SOURCE_NAME = 'source-list';
export const LOCAL_STORAGE_SOURCE_EXPIRE_ITEM = `${SOURCE_NAME}:expire`;
export const LOCAL_STORAGE_SOURCE_ROOMS_ITEM = `${SOURCE_NAME}:prices`;
export const LOCAL_STORAGE_SOURCE_CACHE_VALUE = 1440;
export const LOCAL_STORAGE_SOURCE_CACHE_MEASURE = 'minute';
export const LOCAL_STORAGE_SOURCE_EMPTY_CACHE = '';

/*
export const startScenariosHotel = () => {

    const scenarioslist = {
        "1" : [166267,166511,166513,166514,166558,166560,166566,166571,166572,166575,166587,166588,170855,175208,166589,166591,166594,166595,166666,166672,166687,166716,166729,166730,166741,166748,166757,185818,166912,166915,166916,166976,166977,166978,166980],
        "2" : [167021,167023,167024,167025,167026,258889,167107,167126,167153,167199,167326,167327,167396,167399,167402,167411,167413,175210,167485,167486,167491,167497,167498,167499,167565,167566,167567,167569,167570],
        "3" : [288654,288657,288658,288660,288661]
    }
    Object.keys(scenarioslist).forEach((scenario) => {
        let objScenarioslist = scenarioslist[scenario];
        if (!Array.isArray(objScenarioslist)) {

            let massiv = [];
            Object.keys(objScenarioslist).forEach((item) => {
                scenarioslist[item] = objScenarioslist[item];
                massiv = massiv.concat(objScenarioslist[item]);

            })
            massiv = Array.from(new Set(massiv))
            scenarioslist[scenario] = massiv;
        }
    });

    return scenarioslist;

}

export const scenariosHotel = startScenariosHotel();
*/
